export enum MeinOrtNewsFilter {
  ALLE = 'alle',
  RATHAUS = 'rathaus',
  GEMEINDE = 'gemeinde'
}
